/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'autorun': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" _fill="#C4FFF9" d="M88.102 75.398c0 .602-.2 1.2-.7 1.8-3.8 3.802-7.698 7.7-11.5 11.5-2.3 2.302-5.8-1.198-3.5-3.5l7.4-7.398h-41.2c-.601 0-1.199-.199-1.5-.5-.601-.398-1-1.101-.898-2 .3-13.699 7.199-26.398 19.102-33.5C76.9 28.8 106 40.7 112.603 65.101 119.2 89.801 100.103 113.7 75 114.2c-3.2.102-3.2-4.898 0-5 13.8-.3 26.398-8.398 31.5-21.3 5-12.5 1.898-27.103-7.5-36.603-9.5-9.5-24.102-12.5-36.602-7.5-12.102 4.801-20.102 16.301-21.2 29h38.302l-7.399-7.398c-2.3-2.3 1.301-5.8 3.5-3.5l11.801 11.801c.496.5.7 1.102.7 1.7l-.001-.001z"/>'
  }
})
